// Sort SEO pages by generation date (newest first)
(function() {
  function sortPages() {
    const pagesPanel = document.getElementById('panel-pages');
    if (!pagesPanel) return;
    
    const pagesList = pagesPanel.querySelector('ul[role="list"]');
    if (!pagesList) return;
    
    const container = pagesPanel.querySelector('pages-pagination');
    if (!container) return;
    
    const pagesPerBatch = parseInt(container.dataset.pagesPerBatch) || 13;
    const currentBatch = parseInt(container.dataset.currentBatch) || 1;
    
    const pages = Array.from(pagesList.querySelectorAll('li'));
    if (pages.length === 0) return;
    
    // Sort by data-generation-date attribute
    pages.sort((a, b) => {
      const articleA = a.querySelector('article[data-generation-date]');
      const articleB = b.querySelector('article[data-generation-date]');
      
      const dateA = articleA?.getAttribute('data-generation-date');
      const dateB = articleB?.getAttribute('data-generation-date');
      
      if (!dateA || !dateB) return 0;
      
      // Descending order (newest first)
      return dateB.localeCompare(dateA);
    });
    
    // Reorder DOM and reassign batch numbers
    pages.forEach((page, index) => {
      const newBatch = Math.floor(index / pagesPerBatch) + 1;
      page.dataset.batch = newBatch;
      
      // Show if within current batch, hide otherwise
      if (newBatch <= currentBatch) {
        page.style.display = '';
      } else {
        page.style.display = 'none';
      }
      
      pagesList.appendChild(page);
    });
  }
  
  // Expose function globally for pagination to use
  window.sortSEOPages = sortPages;
  
  // Sort immediately when script loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortPages);
  } else {
    sortPages();
  }
})();